export default async (formData: FormData, articleId: string): Promise<void> => {
  const response = await fetch(`/consultant/articles/${articleId}`, {
    method: 'DELETE',
    body: formData,
  });

  const jsonResponse = await response.json();
  jsonResponse.status = response.status;
  return jsonResponse;
};
